import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api } from "@/lib/api";
import { GalleryStoryEditor } from "@/components/admin/GalleryStoryEditor";

const BASE = process.env.REACT_APP_BACKEND_URL;

export function GalleryItemCard({ item: it, onChanged }) {
  const remove = async () => { await api.delete(`/admin/gallery/${it.id}`); toast.success("Photo removed"); onChanged(); };
  const toggleInstalled = async () => {
    const fd = new FormData(); fd.append("installed", it.installed === false ? "true" : "false");
    await api.patch(`/admin/gallery/${it.id}`, fd); onChanged();
  };
  const setBefore = async (f) => {
    if (!f) return;
    const fd = new FormData(); fd.append("file", f);
    try { await api.post(`/admin/gallery/${it.id}/before`, fd); toast.success("Before photo added — the card now has a drag slider"); onChanged(); }
    catch (err) { toast.error(err?.response?.data?.detail || "Upload failed"); }
  };
  const removeBefore = async () => { await api.delete(`/admin/gallery/${it.id}/before`); toast.success("Before photo removed"); onChanged(); };
  const installed = it.installed !== false;

  return (
    <div className="dg-card rounded-xl overflow-hidden" data-testid={`admin-gallery-item-${it.id}`}>
      <div className="relative">
        <img src={`${BASE}${it.img}`} alt={it.title} className="w-full h-40 object-cover" />
        {it.before_img && <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-black/60 text-white text-[10px] font-mono uppercase tracking-widest">Before / after</span>}
      </div>
      <div className="p-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-sm font-semibold truncate">{it.title}</div>
          <div className="text-xs text-slate-400">{it.category}{it.subtitle ? ` · ${it.subtitle}` : ""}</div>
          <button type="button" onClick={toggleInstalled} className={`mt-2 text-[11px] rounded-full px-2.5 py-1 border transition-colors ${installed ? "border-[#FFD600]/60 text-[#FFD600]" : "border-slate-700 text-slate-500"}`} data-testid={`gallery-installed-toggle-${it.id}`}>
            {installed ? "Installed by David ✓" : "Not tagged as install"}
          </button>
          <div className="mt-2 flex items-center gap-2 flex-wrap text-[11px]">
            <label className="rounded-full px-2.5 py-1 border border-cyan-500/50 text-cyan-300 hover:bg-cyan-500/10 cursor-pointer transition-colors" data-testid={`gallery-before-upload-${it.id}`}>
              {it.before_img ? "Replace before photo" : "Add before photo"}
              <input type="file" accept="image/*" className="hidden" onChange={(e) => { setBefore(e.target.files?.[0]); e.target.value = ""; }} />
            </label>
            {it.before_img && (
              <button type="button" onClick={removeBefore} className="text-slate-400 hover:text-red-400" data-testid={`gallery-before-remove-${it.id}`}>Remove before</button>
            )}
            <GalleryStoryEditor key={it.story || ""} item={it} onSaved={onChanged} />
          </div>
        </div>
        <button onClick={remove} className="text-slate-400 hover:text-red-400 p-1" title="Remove" data-testid={`gallery-delete-${it.id}`}><Trash2 className="w-4 h-4" /></button>
      </div>
    </div>
  );
}
